<template>
  <div class="header">
    <img src="../assets/logo.png"/>
    <span>薛神驾到管理平台</span>
    <div class="right_wrap" v-if="user">
      <span class="expire_container" v-if="user.expired">系统将于<span class="status_error">{{user.factoryAuthEndTime ? user.factoryAuthEndTime.substr(0, 10) : '-'}}</span>到期，<span class="renew_btn" @click="renew">请续费</span></span>
      <span>{{user.name}}（{{$permission.getRoleName(user.type)}}）</span>
      <el-button type="text" size="medium" @click="logout"><el-icon><switch-button /></el-icon>退出</el-button>
    </div>
  </div>

  <el-dialog title="续费" v-model="payVisible" :close-on-click-modal="false" :close-on-press-escape="false" @close="stopTimer" width="300px">
    <div class="pay_container">
      <div class="code" ref="pay_code" id="pay_code"></div>
      <div class="tips">微信扫码支付</div>
      <div class="tips">{{payInfo.fee}}元/年</div>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
let cutDown

export default {
  name: "aui-header",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      user: this.currentUser,
      payVisible: false,
      payInfo: {}
    }
  },
  methods: {
    renew() {
      this.$apis.shopMgr.pay(this.user.sn).then(response => {
        if (response.status === 200) {
          this.payInfo = response.data
          this.payVisible = true
          setTimeout(() => {
            document.getElementById('pay_code').innerHTML = ''
            new QRCode(this.$refs.pay_code, {
              text: this.payInfo.qrcode,
              width: 200,
              height: 200,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
            })
          }, 200)
          cutDown = setInterval(() => {
            this.$apis.shopMgr.payResult(this.payInfo.outTradeNo).then(response => {
              if (response.status === 200) {
                this.stopTimer()
                this.$message({
                  message: '续费成功',
                  type: 'success'
                })
                this.payVisible = false
                this.$apis.shopMgr.get(this.user.sn).then(res => {
                  let user = res.data
                  if (user.type === 0) {
                    user.expired = user.factoryAuthEndTime == null || (new Date(user.factoryAuthEndTime) - new Date()) / (3600000 * 24) <= 30
                  }
                  this.user = user
                  this.$utils.setStorageObj('currentUser', user)
                })
              }
            })
          }, 1500)
        }
      })
    },
    stopTimer() {
      clearInterval(cutDown)
    },
    logout() {
      this.$apis.login.logout().then(() => {
        this.$utils.clearStorage()
        this.$router.replace('/')
      })
    }
  },
  created() {

  }
}
</script>

<style scoped>
.header {
  height: 80px;
  line-height: 80px;
  text-align: left;
  font-size: 38px;
  box-sizing: border-box;
  vertical-align: middle;
  background: #3d3d3d;
}
.header img {
  float: left;
  width: 80px;
  box-sizing: border-box;
  vertical-align: middle;
}
.header>span {
  margin-left: 10px;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  color: #FFFFFF;
}
.header .right_wrap {
  float: right;
  margin-right: 18px;
  font-size: 18px;
  color: #FFFFFF;
}
.header .right_wrap button {
  color: #A1A2A3;
}
.expire_container {
  margin-right: 24px;
  display: inline-block;
  height: 24px;
  line-height: 24px;
  font-size: 13px;
}
.expire_container .renew_btn {
  color: #67C23A;
  text-decoration: underline;
  cursor: pointer;
}
.status_error {
  padding: 0 8px;
  font-size: 16px;
  color: #f56c6c;
}
.pay_container .code {
  margin: 0 auto 12px;
  width: 200px;
}
.pay_container .tips {
  text-align: center;
  font-size: 14px;
  color: #909399;
}

@media only screen and (max-width: 600px) {
  .header>span, .header .right_wrap>span {
    display: none;
  }
}
</style>
